export const SHIPMENT_STATUS_CORRECTION_MAX_ATTACHMENTS = 5;
export const SHIPMENT_STATUS_CORRECTION_MAX_FILE_BYTES = 5 * 1024 * 1024;
export const SHIPMENT_STATUS_CORRECTION_MIN_REASON_LENGTH = 5;

export const SHIPMENT_STATUS_CORRECTION_ACCEPTED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp'] as const;
export const SHIPMENT_STATUS_CORRECTION_ACCEPTED_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const;

export const SHIPMENT_STATUS_CORRECTION_ACCEPT_ATTR = SHIPMENT_STATUS_CORRECTION_ACCEPTED_MIME_TYPES.join(',');

const getFileExtension = (fileName: string): string => {
  const parts = fileName.toLowerCase().split('.');
  return parts.length > 1 ? parts.pop() || '' : '';
};

export const isValidShipmentStatusCorrectionFile = (file: File): boolean => {
  const extension = getFileExtension(file.name);
  return (
    SHIPMENT_STATUS_CORRECTION_ACCEPTED_MIME_TYPES.includes(
      file.type as (typeof SHIPMENT_STATUS_CORRECTION_ACCEPTED_MIME_TYPES)[number],
    ) ||
    SHIPMENT_STATUS_CORRECTION_ACCEPTED_EXTENSIONS.includes(
      extension as (typeof SHIPMENT_STATUS_CORRECTION_ACCEPTED_EXTENSIONS)[number],
    )
  );
};

export type ShipmentStatusCorrectionAttachmentErrorKey = 'max_attachments' | 'invalid_file_type' | 'invalid_file_size';

export const validateShipmentStatusCorrectionAttachments = (
  files: File[],
): ShipmentStatusCorrectionAttachmentErrorKey | null => {
  if (files.length > SHIPMENT_STATUS_CORRECTION_MAX_ATTACHMENTS) {
    return 'max_attachments';
  }

  for (const file of files) {
    if (!isValidShipmentStatusCorrectionFile(file)) {
      return 'invalid_file_type';
    }
    if (file.size > SHIPMENT_STATUS_CORRECTION_MAX_FILE_BYTES) {
      return 'invalid_file_size';
    }
  }

  return null;
};
